import { isAnyEstimuloProduct, isAnyPoligonoProduct } from 'utils/product-utils';
import { getUtmSource } from 'providers/profile.provider';

export type BrandGender = 'feminino' | 'masculino';

export type ProductBrand = {
    branchName: string;
    branchShortName: string;
    gender: BrandGender;
    primaryColor: string;
    secondaryColor: string;
    tertiaryColor: string;
};

export const DEFAULT_BRAND: ProductBrand = {
    branchName: 'BizCapital',
    branchShortName: 'Biz',
    gender: 'feminino',
    primaryColor: '#fac600',
    secondaryColor: '#00a7b5',
    tertiaryColor: '#bbd557',
};

export const ESTIMULO_BRAND: ProductBrand = {
    branchName: 'Estímulo',
    branchShortName: 'Estímulo',
    gender: 'masculino',
    primaryColor: '#0098FC',
    secondaryColor: '#0098FC',
    tertiaryColor: '#0098FC',
};

export const POLIGONO_BRAND: ProductBrand = {
    branchName: 'Polígono Capital',
    branchShortName: 'Polígono',
    gender: 'feminino',
    primaryColor: '#203F2C',
    secondaryColor: '#203F2C',
    tertiaryColor: '#203F2C',
};

export const getProductBrand = (bizId?: string | null): ProductBrand => {
    const id = bizId || getUtmSource();
    if (isAnyPoligonoProduct(id)) return POLIGONO_BRAND;
    if (isAnyEstimuloProduct(id)) return ESTIMULO_BRAND;
    return DEFAULT_BRAND;
};

export const brandArticle = (brand: ProductBrand) => {
    const feminine = brand.gender === 'feminino';

    return {
        o_a:       feminine ? 'a'    : 'o',
        da_do:     feminine ? 'da'   : 'do',
        na_no:     feminine ? 'na'   : 'no',
        pela_pelo: feminine ? 'pela' : 'pelo',
        à_ao:      feminine ? 'à'    : 'ao',
    };
};
